import PropagateLoader from "react-spinners/PropagateLoader"
import React from "react"
import styled from "styled-components"

const LoadingIndicatorView = styled.div`
  display: flex;
  justify-content: center;
`

const LoadingIndicator = ({ loading }: { loading: boolean }) => {
  if (!loading) return null

  return (
    <LoadingIndicatorView>
      <PropagateLoader loading={true} size={10} color={"green"} />
    </LoadingIndicatorView>
  )
}

export default LoadingIndicator
